var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkIssue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_4447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5858 32.4143C71.3668 31.6333 71.3685 30.3622 70.5542 29.6158C53.2868 13.7884 26.7132 13.7884 9.44575 29.6158C8.63149 30.3622 8.63317 31.6333 9.41421 32.4143L12.1858 35.1859C12.9668 35.967 14.2301 35.9622 15.0512 35.2234C29.216 22.4787 50.784 22.4787 64.9488 35.2234C65.7699 35.9622 67.0332 35.967 67.8142 35.1859L70.5858 32.4143Z",
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7858 41.2143C62.5668 40.4333 62.5697 39.1609 61.7432 38.4281C49.3539 27.4444 30.6461 27.4444 18.2568 38.4281C17.4303 39.1609 17.4332 40.4333 18.2142 41.2143L20.9858 43.9859C21.7668 44.767 23.0295 44.7588 23.87 44.0421C33.1456 36.1326 46.8544 36.1326 56.13 44.0421C56.9705 44.7588 58.2332 44.767 59.0142 43.9859L61.7858 41.2143Z",
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9858 50.0144C53.7668 49.2333 53.7722 47.9578 52.9192 47.2561C45.4294 41.0952 34.5706 41.0952 27.0808 47.2561C26.2278 47.9578 26.2332 49.2333 27.0142 50.0144L29.7858 52.786C30.5668 53.567 31.8256 53.5507 32.7208 52.9037C37.053 49.7722 42.947 49.7722 47.2792 52.9037C48.1744 53.5507 49.4332 53.567 50.2142 52.786L52.9858 50.0144Z",
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1858 58.8144C44.9668 58.0334 44.9752 56.7387 44.0241 56.1769C41.5495 54.7151 38.4505 54.7151 35.9759 56.1769C35.0248 56.7387 35.0332 58.0334 35.8142 58.8144L38.5858 61.586C39.3668 62.367 40.6332 62.367 41.4142 61.586L44.1858 58.8144Z",
    fill: "#C1CCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0998 71C52.4841 71 51.4769 69.2325 52.2847 67.8249L60.1849 54.0557C60.9928 52.6481 63.0072 52.6481 63.8151 54.0557L71.7153 67.8249C72.5231 69.2325 71.5159 71 69.9002 71H54.0998Z",
    fill: "#F25467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.25 66.5C63.25 67.1904 62.6904 67.75 62 67.75C61.3096 67.75 60.75 67.1904 60.75 66.5C60.75 65.8096 61.3096 65.25 62 65.25C62.6904 65.25 63.25 65.8096 63.25 66.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 59V63",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_4447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIssue);
export default __webpack_public_path__ + "static/media/network-issue.105bebe723557c33edbf30547104aef1.svg";
export { ForwardRef as ReactComponent };